function Update1() {
    return (<div>
        After winning the Bristol qualifiers, my team were invited to London to compete in the finals. We ended up coming 1st in EMEA and 6th Globally. It was such a valuable experience and I met so many interesting people while visiting the office. It also reminded me how much fun puzzles are, so I've been looking at random puzzles for fun since.
    </div>);
}

export default Update1;